import { Template } from '@go-shared/types/template';
import { BareVenueTemplate } from '@go-shared/types/venueTemplate';
import React from 'react';
import { BubbleButton, BubbleOverlay, BubbleSelect, BubbleTable } from '../BubbleUI';
import { BubbleTableFields, BubbleTableTemplate } from '../BubbleUI/BubbleTable';
import { FormGenericContainer } from '../FormGenericContainer';
import { Targettable, TransferForm } from './TemplateTransferForm';
import TmplTnsfStatusFooter from './TmplTnsfStatusFooter';

interface TmplTransferVenPageProps {
  transferForm: TransferForm;
  template: Template;
  targetVenues: BareVenueTemplate[];
  isBusy: boolean;
  changeTransferForm: <T extends keyof TransferForm>(key: T, val: TransferForm[T]) => void;
  onGoBack?: () => void;
  onGoNext?: () => void;
  onClose?: () => void;
}

export function TmplTransferVenPage(props: TmplTransferVenPageProps) {
  const tableFields: Array<BubbleTableFields<Targettable<BareVenueTemplate>>> = [
    { key: 'source' },
    { key: 'target', tdProps: { className: 'py-0-i' } },
  ];

  const tableTemplates: Array<BubbleTableTemplate<Targettable<BareVenueTemplate>>> = [
    {
      key: 'source',
      render: data => <span className={data.target ? '' : 'text-red-600'}>{data.item.name}</span>,
    },
    {
      key: 'target',
      render: (data, index) => (
        <BubbleSelect
          allowUndefined
          labelExtractor={v => v.name}
          value={data.target}
          options={props.targetVenues}
          undefinedLabel={'Do not transfer'}
          selectClassName={data.target ? '' : 'text-red-600'}
          onValue={val => {
            const newItems = [...props.transferForm.venueMap];
            newItems[index].target = val;
            props.changeTransferForm('venueMap', newItems);
          }}
        />
      ),
    },
  ];

  return (
    <div className="tflf-3">
      <FormGenericContainer
        footerClassName="flex-wrap"
        footer={() => (
          <>
            <TmplTnsfStatusFooter {...props} className="text-slate-dark mr-auto" />
            <BubbleButton
              className="ml-auto"
              variant="navy"
              inverse
              onClick={props.onGoBack}
              disabled={props.isBusy}
            >
              Go Back
            </BubbleButton>
            <BubbleOverlay loading={props.isBusy}>
              <BubbleButton variant="navy" onClick={props.onGoNext}>
                Next: Confirm Content
              </BubbleButton>
            </BubbleOverlay>
          </>
        )}
      >
        <div className="flex items-start mb-5">
          <div>
            <h1 className="text-lg text-slate-dark font-semibold">Transfer Template</h1>
            <h2 className="text-2xl text-navy">3. Map Venues</h2>
          </div>
          <BubbleButton
            disabled={props.isBusy}
            onClick={props.onClose}
            className="ml-auto"
            variant="navy"
            inverse
            icon="xmark-large"
            iconSize="xl"
          />
        </div>
        <BubbleTable
          headVariant="navy"
          striped
          responsive
          fields={tableFields}
          items={props.transferForm.venueMap}
          templates={tableTemplates}
          keyExtractor={i => i.item._id}
        />
      </FormGenericContainer>
    </div>
  );
}
